const { compile } = require('html-to-text');
import ReactDOMServer from 'react-dom/server';

class Helper
{
    formatChangesText(action, data)
    {
        const options = {
            wordwrap: 130,
        };
        
        const formated = this.formatChanges(action, data);

        const html = [];
        formated.forEach(function(item) {
            html.push(ReactDOMServer.renderToStaticMarkup(item));
        });
        
        const compiledConvert = compile(options);
        
        const texts = html.map(compiledConvert);
        //console.log('convert', texts);
        
        const text = texts.join(';\n');
        //console.log('converted', text);
        
        return text;
    }
    
    
    formatChangesFiltersAdd(data)
    {
        var ret = [];

        if('workspaces' in data.filters)
        {
            if('added' in data.filters.workspaces)
            {
                var workspaces = data.filters.workspaces.added.map(function (item) {
                    return item.name;
                });

                if(workspaces.length>0)
                {
                    ret.push(config.texts.changes.filters.workspaces + workspaces.join(", "));
                }
            }
        }

        if('boards' in data.filters)
        {
            if('added' in data.filters.boards)
            {
                var boards = data.filters.boards.added.map(function (item) {
                    return item.name;
                });

                if(boards.length>0)
                {
                    ret.push(config.texts.changes.filters.boards + boards.join(", "));
                }
            }
        }
        
        return ret.join("; ");
    }
    
    
    formatChangesFiltersDeleted(data)
    {
        var ret = [];
        
        if('workspaces' in data.filters)
        {
            if('deleted' in data.filters.workspaces)
            {
                var workspaces = data.filters.workspaces.deleted.map(function (item) {
                    return item.name;
                });

                if(workspaces.length>0)
                {
                    ret.push(config.texts.changes.filters.workspaces + workspaces.join(", "));
                }
            }
        }

        if('boards' in data.filters)
        {
            if('deleted' in data.filters.boards)
            {
                var boards = data.filters.boards.deleted.map(function (item) {
                    return item.name;
                });

                if(boards.length>0)
                {
                    ret.push(config.texts.changes.filters.boards + boards.join(", "));
                }
            }
        }

        return ret.join("; ");
    }
    
    
    formatChangesSharesAdd(data)
    {
        var ret = [];
        
        if('teams' in data.shares)
        {
            if('added' in data.shares.teams)
            {
                var teams = data.shares.teams.added.map(function (item) {
                    return item.name;
                });

                if(teams.length>0)
                {
                    ret.push(config.texts.changes.shares.teams + teams.join(", "));
                }
            }
        }
        
        if('users' in data.shares)
        {
            if('added' in data.shares.users)
            {
                var users = data.shares.users.added.map(function (item) {
                    return item.name;
                });

                if(users.length>0)
                {
                    ret.push(config.texts.changes.shares.users + users.join(", "));
                }
            }
        }
        
        return ret.join("; ");
    }
    
    
    formatChangesSharesDeleted(data)
    {
        var ret = [];
        
        if('teams' in data.shares)
        {
            if('deleted' in data.shares.teams)
            {
                var teams = data.shares.teams.deleted.map(function (item) {
                    return item.name;
                });

                if(teams.length>0)
                {
                    ret.push(config.texts.changes.shares.teams + teams.join(", "));
                }
            }
        }
        
        if('users' in data.shares)
        {
            if('deleted' in data.shares.users)
            {
                var users = data.shares.users.deleted.map(function (item) {
                    return item.name;
                });

                if(users.length>0)
                {
                    ret.push(config.texts.changes.shares.users + users.join(", "));
                }
            }
        }
        
        return ret.join("; ");
    }
    
    
    formatChanges(action, data)
    {
        var ret = [];
        
        if(data == null) return ret;
        
        if('name' in data)
        {

            if(['created','deleted'].some(v => action.includes(v)))
            {
                if('new' in data.name && data.name.new!=null)
                {
                    ret.push(<p key="new_name">{config.texts.changes.name.current} {data.name.new}</p>);
                }
                if('old' in data.name && data.name.old!=null)
                {
                    ret.push(<p key="old_name">{config.texts.changes.name.current} {data.name.old}</p>);
                }
            }
            else
            {
                if('new' in data.name && data.name.new!=null)
                {
                    ret.push(<p key="new_name">{config.texts.changes.name.new} {data.name.new}</p>);
                }
                if('old' in data.name && data.name.old!=null)
                {
                    ret.push(<p key="old_name">{config.texts.changes.name.old} {data.name.old}</p>);
                }
            }

        }
        
        if('description' in data)
        {
            if(['created','deleted'].some(v => action.includes(v)))
            {
                if('new' in data.description && data.description.new!=null)
                {
                    ret.push(<p key="new_description">{config.texts.changes.description.current} {data.description.new}</p>);
                }
                if('old' in data.description && data.description.old!=null)
                {
                    ret.push(<p key="old_description">{config.texts.changes.description.current} {data.description.old}</p>);
                }
            }
            else
            {
                if('new' in data.description && data.description.new!=null)
                {
                    ret.push(<p key="new_description">{config.texts.changes.description.new} {data.description.new}</p>);
                }
                if('old' in data.description && data.description.old!=null)
                {
                    ret.push(<p key="old_description">{config.texts.changes.description.old} {data.description.old}</p>);
                }
            }
            
        }
        
        
        if(('filter' in data) && typeof data.filter === 'object' && !Array.isArray(data.filter) && data.filter !== null)
        {
            var state_new = config.texts.changes.filter.enabled;
            var state_old = config.texts.changes.filter.enabled;
            
            if(('new' in data.filter) && data.filter.new==false)
            {
                state_new = config.texts.changes.filter.disabled;
            }
            if(('old' in data.filter) && data.filter.old==false)
            {
                state_old = config.texts.changes.filter.disabled;
            }
            
            
            if(
                (['created','deleted'].some(v => action.includes(v)))
            )
            {
                if(('new' in data.filter) && data.filter.new!==null)
                {
                    ret.push(<p key="filter">{config.texts.changes.filter.current} {state_new}</p>);
                }
                
                if(('old' in data.filter) && data.filter.old!==null)
                {
                    ret.push(<p key="filter">{config.texts.changes.filter.current} {state_old}</p>);
                }
            }
            else
            {
                if(('new' in data.filter) && ('old' in data.filter) && data.filter.new!=data.filter.old)
                {
                    ret.push(<p key="filter">{config.texts.changes.filter.current} {state_new}</p>);
                }
                /*
                if(('old' in data.filter))
                {
                    ret.push(<p key="filter">{config.texts.changes.filter.current} {state_old}</p>);
                }
                */
            }
        }
        
        
        if('filters' in data)
        {
            var flag_filter = false;
            if(
                (['created','deleted'].some(v => action.includes(v)))
                &&
                (
                    ((('workspaces' in data.filters) && ('added' in data.filters.workspaces)) || (('boards' in data.filters) && ('added' in data.filters.boards)))
                    ||
                    ((('workspaces' in data.filters) && ('deleted' in data.filters.workspaces)) || (('boards' in data.filters) && ('deleted' in data.filters.boards)))
                )
            )
            {
                ret.push(<p key="filters_current">{config.texts.changes.filters.current} {this.formatChangesFiltersAdd(data)}{ this.formatChangesFiltersDeleted(data)}</p>);
                flag_filter = true;
            }
            else
            {
                if( (('workspaces' in data.filters) && ('added' in data.filters.workspaces)) || (('boards' in data.filters) && ('added' in data.filters.boards)) )
                {
                    ret.push(<p key="filters_added">{config.texts.changes.filters.added} {this.formatChangesFiltersAdd(data)}</p>);
                    flag_filter = true;
                }
                
                if( (('workspaces' in data.filters) && ('deleted' in data.filters.workspaces)) || (('boards' in data.filters) && ('deleted' in data.filters.boards)) )
                {
                    
                    ret.push(<p key="filters_deleted">{config.texts.changes.filters.removed} {this.formatChangesFiltersDeleted(data)}</p>);
                    flag_filter = true;
                }
            }
            
            if('archive' in data.filters)
            {
                var pref = "";
                if(!flag_filter) pref = config.texts.changes.filters.current + ' ';
                
                if(data.filters.archive==true)
                {
                    ret.push(<p key="filters_archive">{pref}{config.texts.changes.filters.archive.enabled}</p>);
                }
                else
                {
                    ret.push(<p key="filters_archive">{pref}{config.texts.changes.filters.archive.disabled}</p>);
                }
            }
        }
        
        if('shares' in data)
        {
            if(
                (['created','deleted'].some(v => action.includes(v)))
                &&
                (
                    ((('teams' in data.shares) && ('added' in data.shares.teams)) || (('users' in data.shares) && ('added' in data.shares.users)))
                    ||
                    ((('teams' in data.shares) && ('deleted' in data.shares.teams)) || (('users' in data.shares) && ('deleted' in data.shares.users)))
                )
                

            )
            {
                ret.push(<p key="shares_current">{config.texts.changes.shares.current} {this.formatChangesSharesAdd(data)} {this.formatChangesSharesDeleted(data)}</p>);
            }
            else
            {
                if((('teams' in data.shares) && ('added' in data.shares.teams)) || (('users' in data.shares) && ('added' in data.shares.users)))
                {
                    ret.push(<p key="shares_added">{config.texts.changes.shares.added} {this.formatChangesSharesAdd(data)}</p>);
                }
                
                if((('teams' in data.shares) && ('deleted' in data.shares.teams)) || (('users' in data.shares) && ('deleted' in data.shares.users)))
                {
                    ret.push(<p key="shares_deleted">{config.texts.changes.shares.removed} {this.formatChangesSharesDeleted(data)}</p>);
                }
            }
        }
        
        if('owner' in data)
        {
            if(['created','deleted'].some(v => action.includes(v)))
            {
                if('new' in data.owner && data.owner.new!=null)
                {
                    ret.push(<p key="owner_new">{config.texts.changes.owner.current} {('name' in data.owner.new)?data.owner.new.name:data.owner.new}</p>);
                }
                if('old' in data.owner && data.owner.old!=null)
                {
                    ret.push(<p key="owner_old">{config.texts.changes.owner.current} {('name' in data.owner.old)?data.owner.old.name:data.owner.old}</p>);
                }
            }
            else
            {
                if('new' in data.owner && data.owner.new!=null)
                {
                    ret.push(<p key="owner_new">{config.texts.changes.owner.new} {('name' in data.owner.new)?data.owner.new.name:data.owner.new}</p>);
                }
                if('old' in data.owner && data.owner.old!=null)
                {
                    ret.push(<p key="owner_old">{config.texts.changes.owner.old} {('name' in data.owner.old)?data.owner.old.name:data.owner.old}</p>);
                }
            }
        }
        
        if('fields' in data)
        {
            var current = false;
            if( (['created','deleted'].some(v => action.includes(v))) )
            {
                current = true;
            }
            
            if('added' in data.fields)
            {
                var added = Object.keys(data.fields.added);
                var label = current?config.texts.changes.fields.current.category:config.texts.changes.fields.added.category;
                
                added.forEach(function(key, index) {
                    ret.push(<p key={"fields_category_added_"+index}>{label} { config.feed.tables[key].name }</p>);
                    
                    if('added' in data.fields.added[key])
                    {
                        var fields = data.fields.added[key].added.map(function (item) {
                            return item.name;
                        });

                        if(fields.length>0)
                        {
                            ret.push(<p key={"fields_category_added_"+index+"_fields"}>{config.texts.changes.fields.added.fields} {fields.join(", ")}</p>);
                        }
                    }
                    
                });
                
            }
            if('changed' in data.fields)
            {
                var changed = Object.keys(data.fields.changed);
                
                changed.forEach(function(key, index) {
                    ret.push(<p key={"fields_category_changed_"+index}>{config.texts.changes.fields.changed.category} { config.feed.tables[key].name }</p>);
                    
                    if('added' in data.fields.changed[key])
                    {
                        var fields = data.fields.changed[key].added.map(function (item) {
                            return item.name;
                        });

                        if(fields.length>0)
                        {
                            ret.push(<p key={"fields_category_changed_"+index+"_added"}>{config.texts.changes.fields.changed.added} {fields.join(", ")}</p>);
                        }
                    }
                    
                    if('deleted' in data.fields.changed[key])
                    {
                        var fields = data.fields.changed[key].deleted.map(function (item) {
                            return item.name;
                        });

                        if(fields.length>0)
                        {
                            ret.push(<p key={"fields_category_changed_"+index+"_deleted"}>{config.texts.changes.fields.changed.deleted} {fields.join(", ")}</p>);
                        }
                    }
                    
                });
                
            }
            if('deleted' in data.fields)
            {
                var deleted = Object.keys(data.fields.deleted);
                var label = current?config.texts.changes.fields.current.category:config.texts.changes.fields.deleted.category;
                
                deleted.forEach(function(key, index) {
                    ret.push(<p key={"fields_category_deleted_"+index}>{label} { config.feed.tables[key].name }</p>);
                    
                    if('deleted' in data.fields.deleted[key])
                    {
                        var fields = data.fields.deleted[key].deleted.map(function (item) {
                            return item.name;
                        });

                        if(fields.length>0)
                        {
                            ret.push(<p key={"fields_category_deleted_"+index+"_fields"}>{config.texts.changes.fields.deleted.fields} {fields.join(", ")}</p>);
                        }
                    }
                });
            }
        }
        
        //console.log(ret);
        return ret;
    }
}

export default new Helper();